import React from 'react'
import { getAiToolResultsHeroConfig } from '../../utils/aiTool/resultsHeroConfig'
import '../../css/AiToolResultsPage.css'

const AiToolResultsHero = ({ toolType, meta, loading = false }) => {
  const config = getAiToolResultsHeroConfig(toolType)
  if (!config) return null

  return (
    <section className="ai-tool-results-hero" aria-label="Results summary">
      <div className="eyebrow">{config.eyebrow}</div>
      <h1>
        {config.title[0]}
        <br />
        {config.title[1]}
      </h1>
      <p className="hsub">{config.subtitle}</p>

      {meta ? <div className="ai-tool-results-hero__meta">{meta}</div> : null}

      {config.pills?.length > 0 ? (
        <div className="ai-tool-results-hero__pills hero-feature-pills">
          {config.pills.map((label, index) => (
            <span key={label} className="hero-feature-pill">
              {loading && index === 0 ? '● Generating…' : label}
            </span>
          ))}
        </div>
      ) : null}
    </section>
  )
}

export default AiToolResultsHero
